import { CalendarEvent, User } from "../../../Utilities";
import { MediaAttachmentFormValues } from "../MediaAttachment";
import { SharingPolicyCustomFormValues } from "../SharingPolicy";

export type Base = {
	name: CalendarEvent["name"];
	description: CalendarEvent["description"];
	location: CalendarEvent["location"];
	imageKey: CalendarEvent["imageKey"];
	imageContentType: CalendarEvent["imageContentType"];
	isAllDay: CalendarEvent["isAllDay"];
	startTime: CalendarEvent["startTime"] | null;
	endTime: CalendarEvent["endTime"] | null;
	startDate: CalendarEvent["startDate"] | null;
	isMultiDay: CalendarEvent["isMultiDay"];
	endDate: CalendarEvent["endDate"] | null;
	allowsResponses: CalendarEvent["allowsResponses"];
};

export type Create = Base & {
	mediaAttachments: MediaAttachmentFormValues.CreateInCalendarEvent[];
	sharingPolicy: SharingPolicyCustomFormValues.CreateInParent[];
};

export type CreateRequiredKey = Extract<keyof Create, "name">;

export type CreateSubset<K extends keyof Create = keyof Create> = Pick<Create, CreateRequiredKey | K>;

export const initialCreate: Create = {
	name: "",
	description: "",
	location: "",
	imageKey: "",
	imageContentType: "",
	isAllDay: false,
	startTime: null,
	endTime: null,
	startDate: null,
	isMultiDay: false,
	endDate: null,
	allowsResponses: false,
	mediaAttachments: [],
	sharingPolicy: [SharingPolicyCustomFormValues.blankItemInParent],
};

export type Detail = Base & {
	authorID: User["id"] | null;
	createdAt: CalendarEvent["createdAt"] | null;
};

export type DetailSubset<K extends keyof Detail = keyof Detail> = Pick<Detail, K>;
